import Hook from "../../hook"

class SalesOrderHook extends Hook {
  async afterRender(window) {
    if (
      window.output.Request.Subject != "Sales.OrderItem" ||
      window.output.Request.Prefix != "Multi" ||
      !session.activeWindow.sub
    ) {
      return
    }

    if (session.activeWindow.sub.window.output.Request.Data.Search.length > 0 || session.activeWindow.sub.window.output.Request.Data.SortOn) {
      if (session.activeWindow.sub.window.output.Request.Data.SortOn && session.activeWindow.sub.window.output.Request.Data.SortOn == 'OrderItemID'
        && session.activeWindow.sub.window.output.Request.Data.SortReverse == false
      ) {
        return
      }

      $($(session.activeWindow.sub.window.element).find('button.button-default')[0]).attr("disabled", true)
    }
  }

  /**
   * Set correct filters
   * @param {Window} window - Window
   * @returns {Promise} Promise
   */
  async afterProcess(window) {
    if (
      window.output.Request.Subject == "Sales.OrderItem" &&
      window.output.Request.Prefix == "Multi"
    ) {
      window.filters.usedate = false
      return
    }

    if (
      window.output.Request.Subject != "Sales.Order" ||
      window.output.Request.Prefix != "Multi"
    ) {
      return
    }
    //window.session.translations.Cancelled
    window.filters.usedate = true
    window.output.Filters = []
    window.output.Filters.push({
      Target: "Status",
      Type: "List",
      Selected: 0,
      Options: [
        {
          Key: window.session.translations.StatusAll,
        },
        {
          Key: window.session.translations.StatusCancelled,
          Value: "Cancelled",
        },
        {
          Key: window.session.translations.StatusHold,
          Value: "Hold",
        },
        {
          Key: window.session.translations.StatusPending,
          Value: [
            "Pending",
            "Pending, referral",
            "Pending, partly paid",
            "Pending, partly paid, referral",
          ],
        },
        {
          Key: window.session.translations.StatusProcessing,
          Value: [
            "Processing",
            "Ready to process",
            "Ready to process, referral",
            "Ready to process, paid",
            "Ready to process, paid, referral",
            "Processing, referral",
            "Processing, paid",
            "Processing, paid, referral",
            "In production",
            "In production, referral",
          ],
        },
        {
          Key: window.session.translations.StatusReceived,
          Value: ["Received"],
        },
        {
          Key: window.session.translations.StatusShipped,
          Value: [
            "Shipped",
            "Partly shipped",
            "Partly shipped, partly invoiced",
            "Partly shipped, partly paid",
            "Partly shipped, paid",
            "Shipped, partly invoiced",
            "Shipped invoiced",
            "Shipped, partly invoiced, partly paid",
            "Shipped, partly paid",
            "Shipped, paid",
          ],
        },
      ],
    })
  }
}

/** @ignore */
export default new SalesOrderHook()
